<template>
  <div class="container">
    <CollapsibleListItem icon="mdi-school" :title="$t('EDUCATION.EDUCATIONS')" :expanded="false">
        
        <memlist-static-table
          id="member-table"
          style="width: 100%; table-layout: fixed;"
          class="table-striped"
          :fields="fields"
          :items="items"
          head-variant="light"
          ref="memberTable"
        >

        </memlist-static-table>

    </CollapsibleListItem>

  </div>

</template>

<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';
import CollapsibleListItem from './CollapsibleListItem.vue';

export default {

  name: 'MemberTableEducations',

  props: ['member','items','company','expanded'],
  emits: ['save_data'],
  mixins: [ toasts ],

  components: {
    CollapsibleListItem
  },

  watch: {

  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {
    async save_data() {

      this.$emit('save_data', this.member);

    }

  },

  mounted() {
    this.show_form = this.expanded;

    if (this.is_mobile) {
      this.fields = this.fields.filter((field) => {
        return field.mobile;
      });
    }
  },

  data() {
    return {

      fields: [
        {
          key: 'education.code',
          label: this.$t('EDUCATION.CODE'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        {
          key: 'education.name',
          label: this.$t('EDUCATION.NAME'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        {
          key: 'education.company.name',
          label:  this.$t('EDUCATION.SECTION'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        {
          key: 'period.name',
          label: this.$t('EDUCATION.PERIOD'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short2',
          thClass: 'td-short2'

        },
      ],

      show_form: true,

    };
  }
};

</script>

<style lang="scss" scoped>
  
  
</style>
